// extracted by mini-css-extract-plugin
export default {"individualsWrapper":"Individuals_individualsWrapper__WAVHq"};